import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


//************* UPLOAD  ***************************/
import { UploadUploadNotificacionesService } from '../uploadUploadNotificaciones/uploadUploadNotificaciones.service';
import { Interceptor } from '../../token/interceptor';
import { UploadCalificacionesGeneracionGruposService } from '../uploadCalificacionesGeneracionGrupos/uploadCalificacionesGeneracionGrupos.service';
import { UsuariosDocumentosDigitalesService } from '../usuariosDocumentosDigitales/usuariosDocumentosDigitales.service';
import { UploadTipoEstructuraTipoDocumentoService } from '../uploadTipoEstructuraTipoDocumento/uploadTipoEstructuraTipoDocumento.service';
import { UploadValidacionDocumentoQrService } from '../uploadValidacionDocumentoQr/uploadValidacionDocumentoQr.service';
import { TipoDocumentoService } from '../tipoDocumento/tipoDocumento.service';
import { EstructuraSitioService } from '../estructuraSitio/estructuraSitio.service';
import { PermisosUsuarioService } from '../permisosUsuario/permisosUsuario.service';
import { ProcesadoService } from '../procesado/procesado.service';
import { RegistroComentariosService } from '../registroComentarios/registroComentarios.service';
import { RegistroFirmaElectronicaService } from '../registroFirmaElectronica/RegistroFirmaElectronicaService';
import { TipoEstructuraService } from '../tipoEsctuctura/tipoEstructura.service';
import { UploadCalificacionesCarrerasGruposService } from '../uploadCalificacionesCarrerasGrupos/uploadCalificacionesCarrerasGrupos.service';
import { UploadCalificacionesGeneracionDocentesService } from '../uploadCalificacionesGeneracionDocentes/uploadCalificacionesGeneracionDocentes.service';
import { UploadCalificacionesGeneracionGruposDetalleService } from '../uploadCalificacionesGeneracionGruposDetalle/uploadCalificacionesGeneracionGruposDetalle.service';
import { UploadCalificacionesGruposGeneracionService } from '../uploadCalificacionesGruposGeneracion/uploadCalificacionesGruposGeneracion.service';
import { UploadCalificacionesSeccionesPeriodoService } from '../uploadCalificacionesSeccionesPeriodo/uploadCalificacionesSeccionesPeriodo.service';
import { UploadCompartirDirectorioService } from '../uploadCompartirDirectorio/uploadCompartirDirectorio.service';
import { UploadCompartirDocumentosService } from '../uploadCompartirDocumentos/uploadCompartirDocumentos.service';
import { UploadUsuarioResponsableAreaService } from '../uploadUsuarioResponsableArea/uploadUsuarioResponsableArea.service';
import { DashboardPhotoService } from '../dashboard/dashboard-photo.service';





@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedUploadModule {
  static forRoot(): ModuleWithProviders<SharedUploadModule> {
    return {
      ngModule: SharedUploadModule,

      providers: [
        TipoDocumentoService,
        EstructuraSitioService,
        UploadUploadNotificacionesService,
        RegistroComentariosService,
        TipoEstructuraService,
        PermisosUsuarioService,
        RegistroFirmaElectronicaService, ProcesadoService, UploadCompartirDirectorioService,
        UploadCompartirDocumentosService, UploadCalificacionesCarrerasGruposService,
        UploadCalificacionesGeneracionDocentesService,
        UploadCalificacionesGeneracionGruposDetalleService,
        UploadCalificacionesGeneracionGruposService,
        UploadCalificacionesGruposGeneracionService, UploadCalificacionesSeccionesPeriodoService,
        UsuariosDocumentosDigitalesService,
        UploadTipoEstructuraTipoDocumentoService,
        UploadValidacionDocumentoQrService,
        UploadUsuarioResponsableAreaService,
        DashboardPhotoService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
